<ng-container *ngIf="!isMobileDevice">
	<div class="similar_products">
		<div class="sitemap breadCrumb">
			<a routerLink="/">Home</a>
			<span>/</span>
			<a class="cursor-pointer"
			   (click)="navigate('products/'+product.productGroup,
			'category', product.category.name)">{{product.category.name}}</a>
			<span>/</span>
			<a>{{product.name | truncketHtml:40}}</a>
		</div>
		<button *ngIf="product.specialStatus">
			{{product.specialStatus.name}}
		</button>
	</div>
</ng-container>
<div class="image_container_wrapper">
	<div class="thumbnail_cont">
		<ng-container *ngIf="!isMobileDevice">
			<fb-thumbnails class="tum_comp"
						   [videoThumbnail]="productVideo"
						   [thumbnails]="galleryImageList"
						   (thumIndex)="thumbIndex($event)"
						   [addOnImagePassOn]="addOnImage"></fb-thumbnails>
		</ng-container>
	</div>
	<ng-container *ngIf="!isMobileDevice">
		<div class="big_image_cont">
			<fb-product-big-image [video]="productVideo"
								  [imageGallery]="galleryImageList"
								  [addOnImagePassOn]="addOnImage"></fb-product-big-image>
		</div>
	</ng-container>
	<ng-container *ngIf="isMobileDevice">
		<fb-product-image-mobile [video]="productVideo"
								 [mobileSlider]="galleryImageList"
								 [selectedIndex]="selectedIndexFromThumb"
								 [addOnImagePassOn]="addOnImage"></fb-product-image-mobile>
	</ng-container>

</div>
